import React, { useEffect, useRef, useState } from 'react';

import MCheckBoxView from './MCheckBox.view';

type Props = {
  name?: string;
  className?: string;
  checked?: boolean;
  disabled?: boolean;
  rowCheckbox?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const MCheckBox: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const [checkedState, setCheckedState] = useState<boolean>(props.checked || false);

  const changeBox = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    event.stopPropagation();

    setCheckedState((prev: boolean) => {
      const newValue = !prev;

      return newValue;
    });

    inputRef.current?.click();
  };

  useEffect(() => {
    const checked = props.checked;

    if (checked === undefined) {
      return;
    }

    setCheckedState(() => checked);
  }, [props.checked]);

  return (
    <MCheckBoxView
      inputRef={inputRef}
      name={props.name}
      className={props.className}
      disabled={props.disabled}
      checked={checkedState}
      rowCheckbox={props.rowCheckbox}
      onClickCheckBox={changeBox}
      onChange={props.onChange}
    >
      {props.children}
    </MCheckBoxView>
  );
};

MCheckBox.displayName = 'MCheckBox';
MCheckBox.defaultProps = {};

export default MCheckBox;
